import { KeyboardEventCode } from '@recruitee/user-interface';

export enum SkinColour {
  LightSkinTone = '1F3FB',
  MediumLightSkinTone = '1F3FC',
  MediumSkinTone = '1F3FD',
  MediumDarkSkinTone = '1F3FE',
  DarkSkinTone = '1F3FF',
}

export interface EmojiSkinVariation {
  unified: string;
  symbol: string;
  addedIn: number;
  hasImgTwitter: boolean;
  base: EmojiItem;
}

export type EmojiListNavigationKeys =
  | KeyboardEventCode.ArrowUp
  | KeyboardEventCode.ArrowDown
  | KeyboardEventCode.ArrowRight
  | KeyboardEventCode.ArrowLeft
  | KeyboardEventCode.Enter;

export enum FlatArrayItemType {
  Heading = 'heading',
  EmojiRow = 'emojiRow',
}

export interface EmojiItem {
  unified: string;
  symbol: string;
  shortName: string;
  shortNames: string[];
  category: string;
  sortOrder: number;
  addedIn: number;
  hasImgTwitter: boolean;
  skinVariations: Record<SkinColour, EmojiSkinVariation> | null;
}

interface EmojiDatasourceSkinVariation {
  unified: string;
  non_qualified: string | null;
  image: string;
  sheet_x: number;
  sheet_y: number;
  added_in: string;
  has_img_apple: boolean;
  has_img_google: boolean;
  has_img_twitter: boolean;
  has_img_facebook: boolean;
}

export interface EmojiDataSourceItem {
  name: string;
  unified: string;
  non_qualified: string;
  docomo: string;
  au: string;
  softbank: string;
  google: string;
  image: string;
  sheet_x: number;
  sheet_y: number;
  short_name: string;
  short_names: string[];
  text?: any;
  texts?: any;
  category: string;
  sort_order: number;
  added_in: string;
  has_img_apple: boolean;
  has_img_google: boolean;
  has_img_twitter: boolean;
  has_img_facebook: boolean;
  skin_variations: Record<SkinColour, EmojiDatasourceSkinVariation>;
  obseloted_by?: string;
}

export type EmojiGroup = { name: string; list: EmojiItem[] };
export type EmojiRow = { type: FlatArrayItemType.EmojiRow; data: EmojiItem[] };
export type EmojiHeader = { type: FlatArrayItemType.Heading; name: string };
export type EmojiVirtualScrollData = (EmojiHeader | EmojiRow)[];
